var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow1TracedRightPagination(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.1956 0.0719422C1.04105 0.131286 0.923875 0.225048 0.593828 0.553512C0.0876481 1.05723 0.0187068 1.17754 0.017406 1.55905C0.0167029 1.76405 0.0345623 1.87844 0.0832186 1.98093C0.128465 2.0763 1.25427 3.2276 3.58109 5.55818L7.01224 8.99477L3.5773 12.4312C0.905313 15.1043 0.126566 15.9028 0.0713708 16.0258C0.023945 16.1316 0.000284822 16.2598 3.57153e-06 16.4126C-0.000699554 16.773 0.102098 16.9511 0.590102 17.4352C0.933368 17.7758 1.03423 17.8552 1.20432 17.9186C1.46071 18.0143 1.66363 18.0148 1.92235 17.9202C2.11722 17.8489 2.30024 17.6715 6.24632 13.7278C10.8048 9.17202 10.5451 9.45806 10.5451 8.99459C10.5451 8.53113 10.8048 8.81716 6.24632 4.26123C2.29827 0.315399 2.11733 0.139969 1.92235 0.0688484C1.6681 -0.0239288 1.44285 -0.0229796 1.1956 0.0719422Z",
    fill: "#FF9900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow1TracedRightPagination);
export default __webpack_public_path__ + "static/media/right-arrow 1 (Traced)Right_Pagination.4da44aef718ae8c7c8a578576b4f756e.svg";
export { ForwardRef as ReactComponent };